import useTranslation from 'next-translate/useTranslation'

import { NAMESPACE_MANAGEMENT } from '@/res/namespaces'

import Caption from '../ui/Typo/Caption'

interface Props {
  status: any
}

const DnsStatusSection: React.FC<Props> = ({ status }) => {
  const { t } = useTranslation(NAMESPACE_MANAGEMENT)
  return (
    <div>
      <div>
        {status === 'ACTIV' ? (
          <StatusCard color="bg-green-700 " text={t(`dns_status.${status}`)} />
        ) : status === 'W_RED' ? (
          <StatusCard color="bg-red-700" text={t(`dns_status.${status}`)} />
        ) : (
          <StatusCard color="bg-orange-500" text={t(`dns_status.${status}`)} />
        )}
      </div>
    </div>
  )
}

interface IStatusCard {
  text: string
  color: string
}

const StatusCard: React.FC<IStatusCard> = ({ text, color }) => {
  return (
    <div className={`inline-block items-center ${color} rounded-xl my-2`}>
      <Caption weight="font-medium" className="px-3 py-1 text-white">
        {text}
      </Caption>
    </div>
  )
}
export default DnsStatusSection
